"use client";

import Link from "next/link";

import styles from "@@/styles/not-found.module.scss";

import { ralewayMedium } from "../../utils/fonts";

export default function NotFound() {
	return (
		<div className={`${styles.main} ${ralewayMedium.className}`}>
			<div className={styles.text}>
				<h1>404</h1>
				<div className={styles.divider}></div>
				<p>Not found</p>
			</div>

			<Link href="/public" className={styles.redirection}>
				Go back to home page
			</Link>
		</div>
	);
}
